var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.858.915h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.248 27.914 7.905 37.636a3.001 3.001 0 0 0 3.905 4.556l12.048-10.327 12.047 10.327a3.001 3.001 0 0 0 3.905-4.556l-11.343-9.722 11.343-9.722a3.001 3.001 0 0 0-3.905-4.556L23.858 23.963 11.81 13.636a3.001 3.001 0 0 0-3.905 4.556l11.343 9.722Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.248 24.915 6.905 34.637a3 3 0 0 0 3.905 4.555l12.048-10.326 12.047 10.326a3 3 0 0 0 3.905-4.555l-11.343-9.722 11.343-9.723a3 3 0 0 0-3.905-4.555L22.858 20.963 10.81 10.637a3 3 0 0 0-3.905 4.555l11.343 9.723Z",
    style: {
      fill: "#ff5656",
      stroke: "#000",
      strokeWidth: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6e470665bc0b1f0a98694b8aaf6dd5b5.svg";
export { ForwardRef as ReactComponent };